//@flow

import * as React from 'react'
import { Typography, TextField, InputAdornment } from '@material-ui/core'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import BlockIcon from './block_icon.png'

const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${(p) => p.theme.palette.background.primary};
`

const Container = styled.div`
  max-width: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
`

const Image = styled.img`
  height: 160px;
  margin-bottom: 10px;
`

const StyledLink = styled.a`
  color: #007bff;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

const ContactInfo = () => (
  <Typography variant="body2" color="text.secondary" style={{ marginTop: '8px' }}>
    E-mail: <StyledLink href="mailto:sales@sputnik.systems">sales@sputnik.systems</StyledLink>
    <br />
    Телеграм-бот: <StyledLink href="https://t.me/sputnik_sales_bot">@sputnik_sales_bot</StyledLink>
    <br />
    Телефон: <StyledLink href="tel:88005115232">8 800 511-52-32</StyledLink>
  </Typography>
)

function BlockedPage() {
  const title = 'Кабинет заблокирован'
  const message = `Ваш кабинет был заблокирован в связи с отрицательным балансом и отсутствием его пополнения в течение 5 дней.

Обращаем ваше внимание, что видеозаписи будут записываться и предоставляться пользователям.

Для снятия блокировки пополните баланс Личного кабинета. Доступ будет разблокирован в течении 24 часов после оплаты.
В случае возникновения вопросов обратитесь в Коммерческий отдел Спутника.
`

  const [amount, setAmount] = React.useState('')
  const [balance, setBalance] = React.useState(0)
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState(null)
  const [pdfUrl, setPdfUrl] = React.useState(null)

  React.useEffect(() => {
    const fetchBalance = async () => {
      try {
        const response = await fetch('/allowed_actions/fetch_balance', {
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      })

        const data = await response.json()
        setBalance(data.balance)
      } catch (err) {
        console.log(err)
      }
    }

    fetchBalance()
  }, [])

  const handleClose = () => {
    if (pdfUrl) URL.revokeObjectURL(pdfUrl)
    setPdfUrl(null)
    setAmount('')
    setError(null)
  }

  const handleGenerate = async () => {
    setLoading(true)
    setError(null)
    try {
      const response = await fetch('/allowed_actions/generate_invoice', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ amount: parseInt(amount, 10) }),
      })
      if (!response.ok) {
        const data = await response.json()
        throw new Error(data.message || 'Не удалось создать счёт')
      }
      const blob = await response.blob()
      setPdfUrl(URL.createObjectURL(blob))
    } catch (err) {
      setError(err.message || 'Не удалось создать счёт. Попробуйте снова.')
    } finally {
      setLoading(false)
    }
  }

  if (pdfUrl) {
    return (
      <Wrapper>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100vh' }}>
          <div style={{ padding: '12px 16px', display: 'flex', gap: '12px', alignItems: 'center' }}>
            <StyledLink href="#" onClick={(e) => { e.preventDefault(); handleClose() }}>
              ← Назад
            </StyledLink>
          </div>
          <iframe
            src={pdfUrl}
            title="Счёт на оплату"
            style={{ flex: 1, border: 'none', width: '100%' }}
          />
        </div>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <Container>
        <Image src={BlockIcon} alt="Blocked Account" />
        <Typography align="center" variant="h6" style={{ fontWeight: 'bold' }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" style={{ whiteSpace: 'pre-line', fontWeight: 'bold' }}>
          {`Текущий баланс: ${balance}₽`}
        </Typography>
        <Typography variant="body2" color="text.secondary" style={{ whiteSpace: 'pre-line' }}>
          {message}
        </Typography>
        <ContactInfo />

        <div style={{ width: '100%', marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <TextField
            fullWidth
            label="Сумма счёта"
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            inputProps={{ min: 1, step: 1 }}
            InputProps={{
              endAdornment: <InputAdornment position="end">₽</InputAdornment>,
            }}
          />
          {error && (
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          )}
          <button
            onClick={handleGenerate}
            disabled={!amount || loading}
            style={{
              padding: '10px 24px',
              borderRadius: '24px',
              border: 'none',
              background: '#1976d2',
              color: '#fff',
              fontSize: '14px',
              cursor: 'pointer',
              opacity: !amount || loading ? 0.6 : 1,
            }}
          >
            {loading ? 'Формируем счёт...' : 'Сформировать счёт'}
          </button>
        </div>
      </Container>
    </Wrapper>
  )
}

export default withRouter(BlockedPage)
